<template>
  <span
    @click="toogleDark"
    class="h-[28px] w-[28px] lg:h-[28px] lg:w-[28px] lg:bg-gray-500-f7 bg-slate-50 dark:bg-slate-900 lg:dark:bg-slate-900 dark:text-white text-slate-900 cursor-pointer rounded-full text-[20px] flex flex-col items-center justify-center"
  >
    <Icon icon="heroicons-outline:moon" v-if="!themeSettingsStore.isDark" class="size-[20px]"/>
    <Icon icon="heroicons-outline:sun" v-else-if="themeSettingsStore.isDark" class="size-[20px]" />
  </span>
</template>
<script>
import Icon from "@/components/Icon/index.vue";
import { useThemeSettingsStore } from "@/stores/themeSettings";


export default {
  components: {
    Icon,
  },
  setup(){
    const themeSettingsStore = useThemeSettingsStore()
    function toogleDark() {
      themeSettingsStore.toogleDark()
    }
    return{
      themeSettingsStore,
      toogleDark
    }
  }
};
</script>
<style lang=""></style>
